module.exports = __webpack_public_path__ + "img/icon_01@3x.9d42e086.png";